import styled from 'styled-components';
import colors from '../colors';
import { FatLabel, OnlyIconLabel, ThinLabel } from '../typings';

type ColorPropsI = {
  color?: string;
};

export const ColorFatLabel = styled(FatLabel)<ColorPropsI>`
  background-color: ${(props) => (props.color ? props.color : colors.darkGrey)};

  & svg path {
    fill: ${colors.white};
  }
`;

export const ColorThinLabel = styled(ThinLabel)<ColorPropsI>`
  background-color: ${(props) => (props.color ? props.color : colors.darkGrey)};

  & svg path {
    fill: ${colors.white};
  }
`;

export const ColorOnlyIcon = styled(OnlyIconLabel)<ColorPropsI>`
  background-color: ${(props) => (props.color ? props.color : colors.darkGrey)};

  & svg path {
    fill: ${colors.white};
  }
`;
